import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-play-circle-fill text-background-50 text-lg"></i>
            </div>
            <span className="text-lg font-bold text-foreground-900 font-heading">
              {siteInfo.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
                分类浏览
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-50 rounded-lg border border-background-200/60 py-2 min-w-[180px]">
                  {categories.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-600 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className={`${cat.icon} text-sm`}></i>
                      </div>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl text-foreground-900`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}